module.exports = __webpack_public_path__ + "static/media/profilePic.fed3e4a5.jpeg";